import { Text as NativeText } from 'react-native';
import { pure } from 'recompose';
import styled from 'styled-components';

// ///////////////////////////////////////////////////////
import { spacing, sizes, background, elevation, typography } from '../../../theme/system';
// ///////////////////////////////////////////////////////
const Text = styled(pure(NativeText))`
  /*
   * There seems to be an bug in the android implementation
   * of text-shadow in react-native, so we set the radius
   * to 0 to match the iOS implementation. Should be removed
   * when this issue has been resolved:
   * https://github.com/facebook/react-native/issues/21507
   */
  
  text-shadow-radius: 0;

  /* padding & margin */
  ${spacing}
  /* width & height */
  ${sizes}
  /* background color */
  ${background}
  /* elevation (android only) */
  ${elevation}
  /* typography */
  ${typography}

  text-align: ${p => (p.center ? 'center' : 'left')};
`;

Text.defaultProps = {
    font: 'body',
    clr: 'body',
};

// Used for debugging
Text.displayName = 'Text';

export default Text;
